"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "CommunityLogo___StyledSvg",
  componentId: "sc-1f22oil-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function CommunityLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M386.943 239.86H450v38.171h-51.507l-67.01 44.68-73.977-92.452-74.779 74.779-57.272-57.258-30.279 30.251H30V239.86h49.37l46.085-46.073 57.272 57.258 77.948-77.928 78.75 98.407 47.518-31.664zm-297.69-57.258H50.67c-.86-6.375-1.585-12.75-1.585-19.086C49.085 96.085 96.182 49 163.631 49c30.43 0 58.628 15.975 76.363 39.699C257.73 64.975 285.927 49 316.358 49c67.448 0 114.545 47.085 114.545 114.516 0 12.654-2.195 25.422-5.498 38.172H386.04c4.142-12.903 6.682-25.71 6.682-38.172 0-46.38-29.973-76.344-76.364-76.344-24.608 0-44.902 17.922-53.206 38.172h-46.334c-8.286-20.25-28.58-38.172-53.187-38.172-46.391 0-76.364 29.965-76.364 76.344 0 6.24.802 12.635 1.985 19.086zM239.898 387.02c12.332-10.421 33.103-28.782 55.382-51.723h51.813c-44.844 51.608-91.636 88.482-95.378 91.402a19.09 19.09 0 01-11.722 4.028 19.09 19.09 0 01-11.722-4.028c-4.18-3.263-62.312-49.031-111.261-110.488h50.056c25.906 29.125 53.015 54.261 72.832 70.809z"
  }));
}

var _default = CommunityLogo;
exports["default"] = _default;